import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import Tooltip from '@/components/Common/Tooltip';
const OPACITY_CONSTANTS = {
    MIN: 0,
    MAX: 1,
    STEP: 0.01,
    DEFAULT: 1,
};
/**
 * Компонент для управления цветом и прозрачностью фигур (прямоугольник, круг)
 */
export const ShapeColorSettings = ({ element, onFillChange, onOpacityChange, }) => {
    var _a, _b;
    const [localColor, setLocalColor] = useState('#ffffff');
    const [localOpacity, setLocalOpacity] = useState(OPACITY_CONSTANTS.DEFAULT);
    // Синхронизация с текущим элементом
    useEffect(() => {
        var _a, _b;
        setLocalColor(((_a = element.props) === null || _a === void 0 ? void 0 : _a.fill) || '#ffffff');
        const opacityValue = (_b = element.props) === null || _b === void 0 ? void 0 : _b.opacity;
        const opacity = typeof opacityValue === 'number' && !isNaN(opacityValue)
            ? opacityValue
            : OPACITY_CONSTANTS.DEFAULT;
        setLocalOpacity(opacity);
    }, [(_a = element.props) === null || _a === void 0 ? void 0 : _a.fill, (_b = element.props) === null || _b === void 0 ? void 0 : _b.opacity]);
    const handleColorChange = useCallback((color) => {
        setLocalColor(color);
        onFillChange(color);
    }, [onFillChange]);
    const handleOpacityChange = useCallback((value) => {
        const clampedValue = Math.max(OPACITY_CONSTANTS.MIN, Math.min(OPACITY_CONSTANTS.MAX, value));
        setLocalOpacity(clampedValue);
        onOpacityChange(clampedValue);
    }, [onOpacityChange]);
    return (_jsx("div", { style: {
            background: '#1D2225',
            borderRadius: 10,
            padding: 0,
            paddingRight: 10,
            display: 'flex',
            alignItems: 'center',
            gap: 6,
        }, children: _jsxs("div", { style: {
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '5px 10px',
                gap: 4,
            }, children: [_jsx(Tooltip, { text: "\u0426\u0432\u0435\u0442 \u0437\u0430\u043B\u0438\u0432\u043A\u0438", position: "top", children: _jsx("input", { type: "color", value: localColor, onChange: (e) => handleColorChange(e.target.value), style: {
                            width: 32,
                            height: 32,
                            border: '1px solid rgba(255, 255, 255, 0.08)',
                            background: 'transparent',
                            cursor: 'pointer',
                        } }) }), _jsx(Tooltip, { text: "\u041F\u0440\u043E\u0437\u0440\u0430\u0447\u043D\u043E\u0441\u0442\u044C", position: "top", children: _jsx("input", { type: "range", min: OPACITY_CONSTANTS.MIN, max: OPACITY_CONSTANTS.MAX, step: OPACITY_CONSTANTS.STEP, value: localOpacity, onChange: (e) => handleOpacityChange(parseFloat(e.target.value)), style: {
                            width: 100,
                            height: 4,
                            background: 'rgba(255, 255, 255, 0.1)',
                            borderRadius: 2,
                            outline: 'none',
                            cursor: 'pointer',
                        } }) })] }) }));
};
